import React from 'react';
import "./onboard-dialog-style.scss";
import {ReactComponent as ErrorIcon} from './images/error-icon.svg';
import {ReactComponent as WarningIcon} from './images/warning-icon.svg';
import {ReactComponent as InfoIcon} from './images/info-icon.svg';
import {ReactComponent as MoneyIcon} from './images/money-icon.svg';
import parse from 'html-react-parser';

const OnboardDialog = (props) => {

    const {
        visible,
        error,
        warningIcon,
        infoIcon,
        moneyIcon,
        confirmShow,
        title,
        content,
        confirmText,
        cancelText,
        onClickCancel,
        onClickConfirm,
        cancelShow,
        directingCancel,
        moveCancelAndConfirm
    } = props;

    const renderMoveCancelAndConfirm = () => {
        if (moveCancelAndConfirm) {
            return (
                <>
                    {cancelShow && <button onClick={() => onClickCancel()}
                                           className={directingCancel ? "onboard-dialog-confirm" : "onboard-dialog-cancel"}>{cancelText}</button>}
                    {confirmShow && <button onClick={() => onClickConfirm()}
                                            className={directingCancel ? "onboard-dialog-cancel" : "onboard-dialog-confirm"}>{confirmText}</button>}
                </>
            )
        } else {
            return (
                <>
                    {confirmShow && <button onClick={() => onClickConfirm()}
                                            className={directingCancel ? "onboard-dialog-cancel" : "onboard-dialog-confirm"}>{confirmText}</button>}
                    {cancelShow && <button onClick={() => onClickCancel()}
                                           className={directingCancel ? "onboard-dialog-confirm" : "onboard-dialog-cancel"}>{cancelText}</button>}
                </>
            )
        }
    }

    return (
        visible && (<div>
            <div className="onboard-dialog-opacity"></div>
            <div className="onboard-dialog-root">
                <div className="onboard-dialog">
                    {error && <ErrorIcon className={"onboard-dialog-error-icon"}/>}
                    {warningIcon && <WarningIcon className={"onboard-dialog-warning-icon"}/>}
                    {infoIcon && <InfoIcon className={"onboard-dialog-info-icon"}/>}
                    {moneyIcon && <MoneyIcon className={"onboard-dialog-warning-icon"}/>}
                    <p className="onboard-dialog-title">{title}</p>
                    {content && (<p className="onboard-dialog-content">{parse(content)}</p>)}
                    {renderMoveCancelAndConfirm()}
                </div>
            </div>
        </div>)
    )
};

export default OnboardDialog;
